import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useIsXxS, useIsMedium } from 'hooks/responsive'
import { useStoreView } from 'hooks/useStoreView'
import { Search } from 'components/Layout/components/Header/components/Search' // TODO: Refactor
import { MiniCart } from 'components/MiniCart'
import { Wrapper } from './components/Styled'

export const Actions = () => {
  const { pathname } = useLocation()
  const { isSofiaAndGrace } = useStoreView()
  const isTablet = useIsMedium()
  const isMobile = useIsXxS()
  const quiz = isTablet ? 'Quiz' : 'Need help? Take Our Quiz'
  const survey = isTablet ? 'Survey' : 'Wellness Survey'
  const isCartOrCheckout = pathname === '/cart' || pathname.includes('/checkout')

  return (
    <Wrapper
      isSofiaAndGrace={isSofiaAndGrace}
    >
      {!isMobile && (
        <Search />
      )}
      {isSofiaAndGrace ? (
        <Link className='sofia-btn' to='/product-selector'>
          {quiz}
        </Link>
      ) : (
        <Link className='livbrite-btn' to='/wellness-survey'>
          {survey}
        </Link>
      )}
      {!isCartOrCheckout && (
        <MiniCart />
      )}
    </Wrapper>
  )
}
